var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3987 1.63562H10.0213C9.88114 1.63562 9.68296 1.82714 9.68296 1.94973V6.39352C9.68296 6.51624 9.88114 6.68357 10.0213 6.68357H10.3987V7.73838H6.979V6.68357H7.69476V2.01231H7.65968L5.98824 7.73838H4.69421L3.04431 2.01231H3.00256V6.68357H3.71832V7.73838H0.855286V6.68357H1.22192C1.37287 6.68357 1.57104 6.51624 1.57104 6.39352V1.94969C1.57104 1.82711 1.37287 1.63559 1.22192 1.63559H0.855286V0.580811H4.43534L5.61075 4.72465H5.64318L6.82936 0.580811H10.3987V1.63562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumGrayIcon);
export default __webpack_public_path__ + "static/media/medium-gray-icon.ef871dcbcdf0eba417e235a785f18587.svg";
export { ForwardRef as ReactComponent };